import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import * as actions from '../../../../redux/projects/actions.projects';
import LeftDebugChatPanel from '../LeftDebugChatPanel/LeftDebugChatPanel';
import OutsideClickPanel from '../../../components/OutsideClickPanel/OutsideClickPanel';
import formats from '../../../../const/formats';
import menuItems from '../../../../const/menuItems';
import getCodeMirrorInstance from '../../../../services/mini/getCodeMirrorInstance';
import TextFieldWithJsonWrapper from '../../../components/TextFieldWithJsonWrapper/TextFieldWithJsonWrapper';
import VisualStatePlaceholder from '../VisualStatePlaceholder/VisualStatePlaceholder';
import JsonPanelHeader from '../JsonPanel/JsonPanelHeader';
import PopupButton from '../../../components/Popup/PopupButton';
import PopupButtons from '../../../components/Popup/PopupButtons';
import PopupCancelButton from '../../../components/Popup/PopupCancelButton';
import JsonPanelBody from '../JsonPanel/JsonPanelBody';
import JsonPanel from '../JsonPanel/JsonPanel';
import { smartJSONParse } from '../../../../services/mini/isValidJSON';

var $ = require('jquery');

class VisualStatesPanel extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            opened: false,
            visualState: null,
            visualStateValid: true,
            history: [],
            selectedVisualStateIndex: 0
        };

        this.visualStatePanelEditor = React.createRef();
    }

    componentDidMount() {
        this._isMounted = true;
        document.addEventListener('keydown', this.onKeyCb, false);
    }

    componentDidUpdate(prevProps) {
        const { visualStates, isVisible } = this.props;

        if (visualStates !== prevProps.visualStates || isVisible !== prevProps.isVisible) {
            this.updateVisualStates(visualStates || [], isVisible);
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        document.removeEventListener('keydown', this.onKeyCb, false);
    }

    onKeyCb = (e) => {
        const { opened } = this.state;
        if (e.keyCode === 27 && opened) {
            this.closePanel();
        }
    }

    onChange = (value) => {
        const { history } = this.state;

        if (this.hasUnsavedVisualStateInHistory()) {
            history[history.length - 1].data = value;
        }

        this.setState({ visualState: value, history: history });
    }

    onValidate = (visualStateValid) => {
        this.setState({ visualStateValid });
    }

    clear = () => {
        const { history } = this.state;
        if (history[history.length - 1] && history[history.length - 1].isNew) {
            history[history.length - 1].data = '';
        }

        this.setState({ visualState: '', history: history });
    }

    updateVisualStates = (visualStates, opened) => {
        let curVisualStateInd;

        const { history } = this.state;
        const { selectedVisualStateTs } = this.props;

        if (opened && selectedVisualStateTs) {
            curVisualStateInd = _.findIndex(visualStates, { ts: selectedVisualStateTs });
        } else {
            curVisualStateInd = visualStates.length - 1;
        }

        this.setState({
            history: [...visualStates],
            visualState: visualStates[curVisualStateInd] ? JSON.stringify(visualStates[curVisualStateInd].data, false, 4) : '',
            opened,
            selectedVisualStateIndex: curVisualStateInd
        });
    }

    selectVisualState = (e) => {
        const { history } = this.state;
        const curIndex = +e.target.getAttribute('data-index');
        const curVisualStateTs = +e.target.getAttribute('data-visual-state-ts');
        const visualState = _.isObject(history[curIndex].data) ? JSON.stringify(history[curIndex].data, false, 4) : history[curIndex].data;

        this.setState({
            selectedVisualStateIndex: curIndex,
            visualState: visualState,
        });

        window.dispatchEvent(new CustomEvent("scrollDebugChatToBubble", { detail: { ts: curVisualStateTs } }));
        this.props.selectVisualState({ visualStateTs: curVisualStateTs });
    }

    addVisualState = () => {
        const { history } = this.state;
        const now = Date.now();

        if (!this.hasUnsavedVisualStateInHistory()) {
            history.push({ ts: now, data: '', label: 'New visual state', isNew: true });

            this.setState({
                history: history,
                selectedVisualStateIndex: history.length - 1,
                visualState: ''
            });

            setTimeout(() => {
                const historyListEl = this.refs.historyList;
                $(historyListEl).animate({ scrollTop: historyListEl.scrollHeight }, 100);
                this.focusEditor();
            });
        }
    }

    focusEditor = () => {
        if (this._isMounted) {
            const editor = getCodeMirrorInstance(this.visualStatePanelEditor.current);
            if (!editor) return;
            editor.focus();
        }
    };

    hasUnsavedVisualStateInHistory = () => {
        const { history } = this.state;
        return _.find(history, { isNew: true });
    }

    closePanel = () => {
        let { history } = this.state;

        if (this.hasUnsavedVisualStateInHistory()) {
            history = history.splice(history.length - 1, 1);
        }

        this.setState({
            opened: false,
            visualStateValid: true,
            history
        });
        window.dispatchEvent(new CustomEvent("scrollDebugChatToRememberedPosition"));
        this.props.hideVisualStatePanel();
    }

    saveVisualState = () => {
        const { visualState, visualStateValid } = this.state;
        const { applyVisualStateInDebugChat, hideVisualStatePanel } = this.props;

        if (!visualStateValid) {
            return;
        }

        applyVisualStateInDebugChat({ visualState: visualState === '' ? {} : smartJSONParse(visualState) });
        this.closePanel();
        hideVisualStatePanel();
    }

    handleClickOutside = (e) => {
        const { opened } = this.state;
        const curEl = e.target;
        const exitElements = [
            '.main-header',
            '.debugging-chat_top-btns',
            '.left-debug-chat-panel'
        ];
        let shouldClosePanel = false;
        for (let i = 0; i < exitElements.length; i++) {
            if (curEl.closest(exitElements[i])) {
                shouldClosePanel = true;
                break;
            }
        }

        if (opened && shouldClosePanel) {
            this.closePanel();
        }
    }

    render() {
        const {
            opened,
            visualState,
            selectedVisualStateIndex,
            history,
            visualStateValid
        } = this.state;

        const disableApplyBtn = visualState === null || !visualStateValid;
        const isNew = selectedVisualStateIndex === history.length - 1;

        return (
            <LeftDebugChatPanel opened={opened}>
                <OutsideClickPanel
                    onOutsideClick={this.handleClickOutside}
                    opened={opened}
                    classes="outside-click-panel visual-state-panel-overlay">

                    <div className="visual-state-panel-ext-wrapper">
                        {history.length !== 0 && <div className="visual-state-panel_history">
                            <div className="visual-state-panel_history_header">History</div>
                            <div className="visual-state-panel_history_list" ref="historyList">
                                {history.map((historyEl, index) => {
                                    return !_.isEmpty(historyEl.data) && <div
                                        className={`visual-state-panel_history_list_item ${selectedVisualStateIndex === index && 'selected'} ${(historyEl.ts && !historyEl.isNew) ? (index === history.length - 1 ? 'editable' : 'locked') : ''}`}
                                        key={historyEl.ts}
                                        onClick={this.selectVisualState}
                                        data-index={index}
                                        data-visual-state-ts={historyEl.ts}>
                                        {historyEl.label ?
                                            historyEl.label :
                                            moment(historyEl.ts).format(formats.MM_DD_YY_hh_mm_a)}
                                    </div>;
                                })}
                            </div>
                            <div className="visual-state-panel_history_btn">
                                <div
                                    className={`action-btn middle dark-grey width-100p ${this.hasUnsavedVisualStateInHistory() && 'disabled'}`}
                                    onClick={this.addVisualState}>
                                    Add Visual State
                                </div>
                            </div>
                        </div>}
                        <JsonPanel className={`visual-state-panel ${history.length === 0 && 'no-history'}`}>
                            <JsonPanelHeader
                                title="Visual State"
                                docUrl={`${menuItems.docs.href}/server-api/sending-data/visual-state`}
                                value={visualState}
                                showBtns={true}
                                onClear={isNew ? this.clear : undefined}
                            />
                            <JsonPanelBody>
                                {opened &&
                                    <TextFieldWithJsonWrapper
                                        key={selectedVisualStateIndex}
                                        value={visualState}
                                        placeholder={<VisualStatePlaceholder />}
                                        onChange={this.onChange}
                                        onShiftEnter={this.saveVisualState}
                                        onValidate={this.onValidate} />}
                            </JsonPanelBody>
                            <PopupButtons>
                                <PopupCancelButton action={this.closePanel} />
                                <PopupButton
                                    label="Apply Visual State"
                                    action={this.saveVisualState}
                                    className={disableApplyBtn && 'disabled'}
                                />
                            </PopupButtons>
                        </JsonPanel>
                    </div>
                </OutsideClickPanel>
            </LeftDebugChatPanel>
        );
    }
}

function mapStateToProps({ projectsInfo }, ownProps) {
    const {
        visualStates,
        visualState,
        selectedVisualStateTs,
        visualStatePanelOpened
    } = projectsInfo.currentProject;

    return {
        visualStates,
        visualState,
        selectedVisualStateTs,
        isVisible: visualStatePanelOpened
    };
}

function mapDispatchToProps(dispatch) {
    return {
        selectVisualState: (param) => dispatch(actions.selectVisualState(param)),
        applyVisualStateInDebugChat: (param) => dispatch(actions.applyVisualStateInDebugChat(param)),
        hideVisualStatePanel: (param) => dispatch(actions.hideVisualStatePanel(param)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualStatesPanel);
